import {MenuModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import HeaderLink from "../HeaderComponents/HeaderLink"

import styles from "./Navigation.module.scss"
type Props = {
	menu: MenuModuleType[]
	setIsShown: (navBarIndex: number) => void
	isShown: number
	isScrolled: boolean
}

const Navigation = (props: Props) => {
	// const [isShown, setIsShown] = useState(-1)
	const {isShown, setIsShown} = props
	return (
		<nav className={styles.navWrapper}>
			<ul
				className={styles.navList}
				// onMouseLeave={() => setIsShown(-1)}
			>
				{props.menu.map(
					(navBar: MenuModuleType, navBarIndex: number) => {
						const {parent, children} = navBar
						const asLink = !parent && children?.length === 0
						const asExpanded =
							!parent && children && children?.length > 0

						return (
							<React.Fragment key={navBarIndex}>
								{asExpanded && (
									<HeaderLink
										isScrolled={props.isScrolled}
										last={
											props.menu.length - 1 ===
											navBarIndex
												? "last"
												: undefined
										}
										asExpanded={{
											isShown,
											navBarIndex,
											setIsShown,
										}}
										data={navBar}
									/>
								)}
								{asLink && (
									<HeaderLink
										isScrolled={props.isScrolled}
										data={navBar}
										asLink
									/>
								)}
							</React.Fragment>
						)
					},
				)}
			</ul>
		</nav>
	)
}

export default Navigation
